import { Scrollbars } from "react-custom-scrollbars";
import type FixMeLater from "../shared/types/fixMeLater.type";

const CustomScrollbars = (props?: FixMeLater) => <Scrollbars {...props} autoHide renderTrackHorizontal={(props) => <div {...props} style={{ display: "none" }} className="track-horizontal" />} />;

export default CustomScrollbars;
